export default {
	0: "Going",
	1: "Confirmed",
	2: "Went",
	3: "NotGo",
	9: "Canceled"
};
